import { useEffect, useState } from "react";
import api from "@/lib/api";

export function EvidenceImage({ path, alt }) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let revoked = null;
    api
      .get(`/files/${path}`, { responseType: "blob" })
      .then((res) => {
        const u = URL.createObjectURL(res.data);
        revoked = u;
        setUrl(u);
      })
      .catch(() => {});
    return () => {
      if (revoked) URL.revokeObjectURL(revoked);
    };
  }, [path]);

  if (!url) return <div className="h-40 w-full rounded bg-slate-950 animate-pulse" />;
  return <img src={url} alt={alt} className="max-h-64 w-full object-contain rounded bg-slate-950 border border-slate-800" />;
}
